import { render } from "./sub-title.vue?vue&type=template&id=55db6535"
import script from "./sub-title.vue?vue&type=script&lang=js"
export * from "./sub-title.vue?vue&type=script&lang=js"

import "./sub-title.vue?vue&type=style&index=0&id=55db6535&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/text/sub-title.vue'],['render',render],['__file',"sub-title.vue"]])

export default __exports__